import BaseRestService from "@/services/base-rest.service";
import $http from "@/plugins/axios";
import {stringify} from "querystring";


export const ApplicationService = {
    ...BaseRestService("/application"),
    createIntegrationToken(data) {
        return $http.post(`/auth/integration-token`, data)
    },
    setWebhook(id, data) {
        return $http.post(`/application/${id}/set-webhook`, data)
    }
}
export const BotService = BaseRestService('/bot')

export const EventService = BaseRestService('/event')

export const EventConfigService = BaseRestService('/event-config')
export const AuthService = {
    signIn(provider) {
        const openIdParams = {
            client_id: provider.client_id,
            scope: 'openid+profile+email+phone',
            response_type: 'code',
            redirect_uri: provider.redirect_uri
        }
        const openIdQueryParams = unescape(stringify(openIdParams));
        window.location.href = `${provider.oidc_endpoint}/protocol/openid-connect/auth?${openIdQueryParams}`
    },
    signOut(provider) {
        $http.post('/auth/logout', {})
        window.location.href =
            `${provider.oidc_endpoint}/protocol/openid-connect/logout?post_logout_redirect_uri=${window.location.origin}&client_id=${provider.client_id}&provider=${provider.name}`
    },
    getToken(provider, code) {
        const providerParam = provider.name.replace('_', '-')
        return $http.get(`/auth/${providerParam}/token?code=${code}`)
    },
    getProvider(provider) {
        const redirect_uri = `${window.location.origin}/authentication/complete`
        return {
            client_id: process.env[`VUE_APP_${provider.toUpperCase()}_CLIENT_ID`],
            redirect_uri: redirect_uri,
            oidc_endpoint: process.env[`VUE_APP_${provider.toUpperCase()}_OIDC_ENDPOINT`],
            name: provider
        }
    }

}
export default {
    ApplicationService,
    BotService,
    AuthService,
    EventService,
    EventConfigService
}
